import { render, staticRenderFns } from "./VendorAddress.vue?vue&type=template&id=f9538146"
import script from "./VendorAddress.vue?vue&type=script&lang=js"
export * from "./VendorAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports